<template>
  <section class="contestHome">
    <div class="content">
      <div class="warp">
        <div class="container">
          <div v-html="content"></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  metaInfo() {
    return {
      title: this.$t("global.竞赛首页") + " | MANA"
    };
  },
  data() {
    return {
      content: ""
    };
  },
  created() {
    this.init();
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  methods: {
    init() {
      this.getDetail();
    },
    getDetail() {
      this.contestName = this.$route.params.contestName;
      if (this.contestName) {
        this.$http
          .get("/api/nmatch/url/" + this.contestName)
          .then(response => {
            if (response.code === "OK") {
              this.content = this.language === "zh"?response.data.zhPrizeNoticeCode:response.data.enPrizeNoticeCode||response.data.zhPrizeNoticeCode;
            }
          });
      }
    }
  }
};
</script>
<style scoped>
.contestHome {
  min-height: calc(100vh - 665px);
}
.content .nav {
  display: flex;
  flex-direction: row;
  padding: 40px 0;
}
.nav li {
  height: 25px;
  margin-right: 40px;
}
.nav li a {
  line-height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #999;
}
.nav li a.selected {
  color: #333;
  font-weight: 600;
}
.warp {
  width: 1160px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
}
.warp .container {
  flex: 1;
  margin: 0;
}
.warp .right {
  width: 250px;
  margin-top: -60px;
  padding-left: 10px;
}
.rightIntro ul {
  display: flex;
  flex-direction: column;
}
.rightIntro ul li {
  padding-right: 2px;
  margin-bottom: 20px;
  border-bottom: none;
}
.rightIntro ul li a {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.geek_text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 10px;
}
.geekText {
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  color: #333;
  font-size: 14px;
}
.geekTime {
  text-align: left;
  margin-bottom: 0;
  color: #999;
}
.container {
  font-size: 14px;
}
</style>





// WEBPACK FOOTER //
// src/pages/match/contestAwards.vue